import { DiscoveryRequest } from "../models/DiscoveryRequest";
import api from "./api";
import { clean } from "../utils/utils";
import { Task } from "../models/Task";
import { File } from "../models/File";

const PATH = "/api/v1/discovery-requests";

export const DiscoveryRequestService = {
  async getDiscoveryRequest(
    discoveryRequestId: string,
  ): Promise<DiscoveryRequest | null> {
    const res = await api.get(`${PATH}/${discoveryRequestId}`);
    return res.data.data;
  },

  async getAllDiscoveryRequests(matterId: string): Promise<DiscoveryRequest[]> {
    const res = await api.get<DiscoveryRequest[]>(PATH, {
      params: { matterId },
    });
    return res.data;
  },

  async createDiscoveryRequest(
    discoveryRequestData: Omit<
      DiscoveryRequest,
      "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
    >,
  ): Promise<DiscoveryRequest["_id"]> {
    const res = await api.post(PATH, {
      ...clean(discoveryRequestData),
    });
    return res.data.data._id;
  },

  async updateDiscoveryRequest(
    matterId: string,
    discoveryRequestId: string,
    updatedData: Partial<Omit<DiscoveryRequest, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${discoveryRequestId}`, {
      ...clean(updatedData),
      matterId,
    });
  },

  async deleteDiscoveryRequest(discoveryRequestId: string): Promise<void> {
    await api.delete(`${PATH}/${discoveryRequestId}`);
  },

  async getTasks(discoveryRequestId: string): Promise<Task[]> {
    const res = await api.get(`${PATH}/${discoveryRequestId}/tasks`);
    return res.data.data ?? [];
  },

  async getFiles(discoveryRequestId: string): Promise<File[]> {
    const res = await api.get(`${PATH}/${discoveryRequestId}/files`);
    return res.data.data ?? [];
  },

  async getDownloadURL(discoveryRequestId: string): Promise<string> {
    const res = await api.get(`${PATH}/${discoveryRequestId}/download`);
    return res.data.data;
  },
};
